import { render, staticRenderFns } from "./SelectPatient.vue?vue&type=template&id=f55289f6&"
import script from "./SelectPatient.vue?vue&type=script&lang=js&"
export * from "./SelectPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports